import contentTypeBuilder from '../../../node_modules/@strapi/plugin-content-type-builder/strapi-admin.js';
import email from '../../../node_modules/@strapi/plugin-email/strapi-admin.js';
import upload from '../../../node_modules/@strapi/plugin-upload/strapi-admin.js';
import customFields from '../../../src/plugins/custom-fields/strapi-admin.js';
import importing from '../../../src/plugins/importing/strapi-admin.js';
import widenLibrary from '../../../src/plugins/widen-library/strapi-admin.js';
import wysiwyg from '../../../src/plugins/wysiwyg/strapi-admin.js';
import courseEditor from '../../../src/plugins/course-editor/strapi-admin.js';
import criticalConcepts from '../../../src/plugins/critical-concepts/strapi-admin.js';
import glossary from '../../../src/plugins/glossary/strapi-admin.js';
import learningObjectives from '../../../src/plugins/learning-objectives/strapi-admin.js';
import topics from '../../../src/plugins/topics/strapi-admin.js';
import courses from '../../../src/plugins/courses/strapi-admin.js';
import flashcards from '../../../src/plugins/flashcards/strapi-admin.js';
import containers from '../../../src/plugins/containers/strapi-admin.js';
import reports from '../../../src/plugins/reports/strapi-admin.js';
import activityEditor from '../../../src/plugins/activity-editor/strapi-admin.js';
import courseCopy from '../../../src/plugins/course-copy/strapi-admin.js';
import contentQuality from '../../../src/plugins/content-quality/strapi-admin.js';
import contentSearch from '../../../src/plugins/content-search/strapi-admin.js';
import assessments from '../../../src/plugins/assessments/strapi-admin.js';
import contentExport from '../../../src/plugins/content-export/strapi-admin.js';
import contentProvider from '../../../src/plugins/content-provider/strapi-admin.js';
import speaker from '../../../src/plugins/speaker/strapi-admin.js';
import cribSheet from '../../../src/plugins/crib-sheet/strapi-admin.js';
import skills from '../../../src/plugins/skills/strapi-admin.js';
import documentation from '../../../node_modules/@strapi/plugin-documentation/strapi-admin.js';
import i18N from '../../../node_modules/@strapi/plugin-i18n/strapi-admin.js';
import usersPermissions from '../../../node_modules/@strapi/plugin-users-permissions/strapi-admin.js';
const plugins = {
  'content-type-builder': contentTypeBuilder,
  'email': email,
  'upload': upload,
  'custom-fields': customFields,
  'importing': importing,
  'widen-library': widenLibrary,
  'wysiwyg': wysiwyg,
  'course-editor': courseEditor,
  'critical-concepts': criticalConcepts,
  'glossary': glossary,
  'learning-objectives': learningObjectives,
  'topics': topics,
  'courses': courses,
  'flashcards': flashcards,
  'containers': containers,
  'reports': reports,
  'activity-editor': activityEditor,
  'course-copy': courseCopy,
  'content-quality': contentQuality,
  'content-search': contentSearch,
  'assessments': assessments,
  'content-export': contentExport,
  'content-provider': contentProvider,
  'speaker': speaker,
  'crib-sheet': cribSheet,
  'skills': skills,
  'documentation': documentation,
  'i18n': i18N,
  'users-permissions': usersPermissions
};
export default plugins;